import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "./works.css";

const MotionLink = motion(Link);

const cardFade = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] } },
};

export const AI_PROJECTS = [
    {
        title: "EndView — AI Interview Platform",
        desc: "Voice-based interview platform that conducts live interviews and returns instant, scored feedback.",
        tags: ["Vapi", "Groq", "Next.js", "Firebase"],
        url: "https://github.com/mohammed0Swalih/endview",
        caseStudy: "/endview",
        live: true,
    },
    {
        title: "MedChat — RAG Medical Chatbot",
        desc: "Voice-enabled medical RAG chatbot with grounded, source-cited answers.",
        tags: ["LangChain", "Pinecone", "Whisper", "Chainlit"],
        url: "https://github.com/mohammed0Swalih/medChatBot_Swalih",
        caseStudy: "/medchat",
    },
    {
        title: "ID OCR + MRZ Extractor",
        desc: "Extracts the portrait, key fields, and MRZ from ID documents — a FastAPI KYC/KYB service.",
        tags: ["FastAPI", "OpenCV", "EasyOCR", "MRZ"],
        url: "https://github.com/mohammed0Swalih/photoDetectionAndOCRExtr",
        caseStudy: "/photoextr",
    },
    {
        title: "FBlur — Video Face Blur",
        desc: "Detects and blurs every face in a video — automated privacy protection, even in low light.",
        tags: ["YOLOv10", "OpenCV", "CLAHE", "Streamlit"],
        url: "https://github.com/mohammed0Swalih/fblur",
        caseStudy: "/fblur",
    },
];

export function RepoCard({ p }) {
    const inner = (
        <>
            <div className="repoTop">
                <span className="repoIcon" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0016 8c0-4.42-3.58-8-8-8z" />
                    </svg>
                </span>
                {p.live && <span className="repoLive"><span className="dot" /> Live UI</span>}
                <span className="repoGit">{p.caseStudy ? "Case study" : "GitHub"} <span className="arw">↗</span></span>
            </div>
            <h3 className="repoTitle">{p.title}</h3>
            <p className="repoDesc">{p.desc}</p>
            <div className="repoStack">
                {p.tags.map((t) => <span key={t}>{t}</span>)}
            </div>
        </>
    );

    const common = {
        className: "repoCard",
        variants: cardFade,
        initial: "hidden",
        animate: "visible",
        whileHover: { y: -4 },
    };

    if (p.caseStudy) {
        return <MotionLink to={p.caseStudy} {...common}>{inner}</MotionLink>;
    }
    return <motion.a href={p.url} target="_blank" rel="noreferrer" {...common}>{inner}</motion.a>;
}
